document.addEventListener('DOMContentLoaded', function () {

    const swiperEl = document.querySelector('.video-slider-content .swiper-video');

    if (swiperEl) {
        // 1) Click handler pe container (funcționează și pentru slide-urile clonate)
        swiperEl.addEventListener('click', async (e) => {
            const btn = e.target.closest('.video-play-btn');
            if (!btn) return;
    
            const slide = btn.closest('.swiper-slide');
            if (!slide) return;
    
            const video = slide.querySelector('video');
            const icon = btn.querySelector('i');
            if (!video || !icon) return;
    
            try {
                if (video.paused) {
                    await video.play(); // prinde și cazurile când browserul respinge play()
                    icon.classList.remove('fa-play');
                    icon.classList.add('fa-pause');
                } else {
                    video.pause();
                    icon.classList.remove('fa-pause');
                    icon.classList.add('fa-play');
                }
            } catch (err) {
                console.warn('Video play blocked:', err);
            }
        });
    }

    const swiper = new Swiper('.video-slider-content .swiper-video', {
        slidesPerView: 4.5,
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            0: { slidesPerView: 1.5, centeredSlides: true },
            576: { slidesPerView: 1.4, centeredSlides: true },
            768: { slidesPerView: 2.4, centeredSlides: true },
            1024: { slidesPerView: 3.4, centeredSlides: true },
            1440: { slidesPerView: 4.5, centeredSlides: true }
        },
        on: {
            slideChange: function () {
                // pauză la toate videourile care NU sunt pe slide-ul activ
                this.slides.forEach((slideEl) => {
                    if (slideEl.classList.contains('swiper-slide-active')) return;

                    const video = slideEl.querySelector('video');
                    const icon = slideEl.querySelector('.video-play-btn i');

                    if (video) video.pause();
                    if (icon) {
                        icon.classList.remove('fa-pause');
                        icon.classList.add('fa-play');
                    }
                });
            }
        }
    });

    const tabs = document.querySelectorAll('.tabs-video-sliders .tab-button');
    function stopAllVideos() {
        document.querySelectorAll('.swiper-slide video').forEach(video => {
            video.pause();
            video.currentTime = 0;
        });
    }

    function setActiveTab(tab) {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {

            const targetId = this.dataset.target;
            const targetSlide = document.getElementById(targetId);

            if (!targetSlide) return;

            const slideIndex = Array.from(targetSlide.parentNode.children)
                .indexOf(targetSlide);

            // 1) tab activ
            setActiveTab(this);

            // 2) mută swiper la slide
            swiper.slideTo(slideIndex);

            // 3) oprește toate video-urile
            stopAllVideos();

            // 4) pornește video-ul din slide-ul target
            const video = targetSlide.querySelector('video');
            if (video) {
                video.play().catch(() => { });
            }
        });
    });

});


// WEBPACK FOOTER //
// ./resources/js/modules/videoSlidersInstaStory.js